
import React from 'react'
import TransitTypes from './transit-types'
import RouteOptions from './route-options'
import Box from '@mui/material/Box';
import useStyles from  '../../styles/style'

 function  OptionTripSettings(props) {

   const { classes } = useStyles();
        return (
            <Box className={classes.shellFilter}>
                <Box mt={1}>
                    <TransitTypes/>
                </Box>
                <Box>
                    <RouteOptions/>
                </Box>
            </Box>

        )

}

export default OptionTripSettings